<mibp-popup-container
  (closed)="onPopupClosed($event)"
  [groupName]="'onboardingPopovers'"
  [attachToBody]="false"
  [closeOnClickOutside]="false"
  [closeOnResize]="false"
  [useArrow]="true"
  [anchorTo]="stepAnchorTo"
  [anchorPosition]="stepAnchorPosition"
  [closeOnScroll]="false">

  <div class="my-featuretour" [attr.data-step]="currentStep + 1">
    <div class="my-featuretour__step"><span>{{currentStep + 1}}</span></div>
    <div class="my-featuretour__contentwrapper">
      <div class="my-featuretour__title">
        <h3 class="my-header onboarding__title ">@if (stepTitleResourceKey) {
          <mibp-resource-string [key]="stepTitleResourceKey"></mibp-resource-string>
        }</h3>
        <div class="my-featuretour__cornerclose"><a href="javascript:void(0)" (click)="close()">x</a></div>
      </div>
      <div class="my-featuretour__body my-body">@if (stepTitleResourceKey) {
        <mibp-resource-string [key]="stepBodyResourceKey" [isHtml]="true"></mibp-resource-string>
      }</div>
      <div class="my-featuretour__footer">
        <div class="my-featuretour__steps">
          <mibp-resource-string key="Global_StepXOfY" [macros]="{ step: currentStep + 1, count: $safeNavigationMigration(currentSteps?.length)}"></mibp-resource-string>
        </div>
        <div class="my-featuretour__actions">
          @if (currentStep > 0) {
            <button class="my-button" type="button" (click)="prevStep()"><mibp-resource-string key="Global_Back"></mibp-resource-string></button>
          }
          @if (currentStep < currentSteps?.length - 1) {
            <button class="my-button" type="button" (click)="nextStep()"><mibp-resource-string key="Global_Next"></mibp-resource-string></button>
          }
          @if (currentStep != currentSteps?.length - 1) {
            <p class="skipTour"><a href="javascript:void(0)" (click)="skipTour()"><mibp-resource-string key="NewFeature_SkipTour"></mibp-resource-string></a></p>
          }
          @if (currentStep == currentSteps?.length - 1) {
            <button class="my-button" type="button" (click)="done()"><mibp-resource-string key="Onboarding_Done"></mibp-resource-string></button>
          }
        </div>
      </div>
    </div>
  </div>

</mibp-popup-container>
